import { Web3InteractionSuccessType } from './Web3InteractionSuccessType';
import i18next from 'i18next';
import { PATH_OF_ROUTES } from '../../router/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Grid from '@mui/material/Grid';
import { web3InteractionSuccessStyles } from './web3InteractionSuccessStyles';
import { Theme, useTheme } from '@mui/material/styles';
import { cleanClaim } from '../../store/claim/actions/cleanClaim';
import {
  VESTING_1_ADDRESS,
  VESTING_2_ADDRESS,
  VESTING_3_ADDRESS
} from '../../services/endpoints';
import { getVestingInfo } from '../../store/vestingInfo/actions/getVestingInfo';
import { AnimationSuccess } from '../AnimationSuccess/AnimationSuccess';

export const useWeb3InteractionSuccess = (
  successType: Web3InteractionSuccessType
) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const successPageActionsMap = {
    [Web3InteractionSuccessType.Claim]: {
      selectTitle: () => i18next.t('vesting.claim.success_title'),
      SuccessContent: () => {
        const theme: Theme = useTheme();
        const isDark = theme.palette.mode === 'dark';
        const classes = web3InteractionSuccessStyles(theme, isDark);

        return (
          <Grid
            item
            container
            direction='column'
            alignItems='center'
            justifyContent='center'
            rowSpacing={0.3}
            sx={classes.txDataContainer}
          >
            <AnimationSuccess />
          </Grid>
        );
      },
      continueAction: () => {
        const vestingContractAddresses = [
          VESTING_1_ADDRESS,
          VESTING_2_ADDRESS,
          VESTING_3_ADDRESS
        ];
        dispatch(cleanClaim());
        dispatch(getVestingInfo({ vestingContractAddresses }));
        navigate(`${PATH_OF_ROUTES.BASE}`, {
          replace: true,
          state: { from: location }
        });
      }
    }
  };

  return {
    title: successPageActionsMap[successType]?.selectTitle(),
    continueAction: successPageActionsMap[successType]?.continueAction,
    SuccessContent: successPageActionsMap[successType]?.SuccessContent
  };
};
